/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/styles/global.css"
import React from "react"
import {
  captureTTCLID,
  initTikTokPixel,
  trackTikTokPageView,
  hasMarketingConsent,
} from "./src/utils/tiktok-pixel"

const loadContentsquare = () => {
  if (typeof window === "undefined") return
  if (window.__contentsquareLoaded) return
  if (document.querySelector('script[data-contentsquare="uxa"]')) return

  const script = document.createElement("script")
  script.src = "https://t.contentsquare.net/uxa/4a4008a629314.js"
  script.async = true
  script.defer = true
  script.setAttribute("data-contentsquare", "uxa")
  script.onload = () => {
    window.__contentsquareLoaded = true
  }
  document.head.appendChild(script)
}

export const onClientEntry = () => {
  // Capture TTCLID immediately on page load
  captureTTCLID()

  // Initialize TikTok Pixel if consent already granted
  if (hasMarketingConsent()) {
    initTikTokPixel()
  }

  // Listen for consent granted event
  if (typeof window !== "undefined") {
    window.addEventListener("marketing-consent-granted", () => {
      initTikTokPixel()
    })
  }
}

export const onInitialClientRender = () => {
  // Delay third-party DOM instrumentation until after hydration.
  if (typeof window === "undefined") return
  window.requestAnimationFrame(() => {
    window.setTimeout(loadContentsquare, 0)
  })
}

export const onRouteUpdate = ({ location }) => {
  // Capture TTCLID on route changes (in case URL changes)
  captureTTCLID()

  // Fire Google Analytics page_view only if user has granted consent
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: location.pathname,
    })
  }

  // Track TikTok Pixel page view on route change (consent checked inside)
  trackTikTokPageView()

  // Track Meta Pixel page view on client-side route changes
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView")
  }
}

export const wrapRootElement = ({ element }) => {
  return <>{element}</>
}
